// 接口域名
export const BASE_URL = process.env.VUE_APP_BASE_API;

// 上传文件的地址
export const upload_file_URL = BASE_URL + "file/upload-file/";

// 图片展示的链接前缀
export const file_before_url = BASE_URL + "media/";
